import { PageMeta } from '../insights/insights.models';

export const LEARNING_JOURNEY_PROGRESSION_PAGE_META: Record<string, PageMeta> = {
	'^/learning-journey-progression/': {
		pagegroup: 'learning-journeys',
		pagename: 'learning-journey-progression'
	}
};
